// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"ccf43916","220":"52faa940","723":"85bca778","752":"d1845150","753":"dbd963c5"}[chunkId] + ".chunk.js";
};